export default function checkoutAddress({ main, on, elm, state, publish }) {
	const option = elm.closest('.checkout-option').querySelector('[name="shipping_method"]');

	main(_ => {
		checkOptionStatus();

		document.addEventListener('change', handleMethodChanged);
		on('change', '#city', cityChanged)
	});

	const checkOptionStatus = function () {
		const status = option.checked;

		state.set(s => s.active = status);
	};

	const handleMethodChanged = function (e) {
		const method = e.target.closest('[name="shipping_method"]');
		if (!method) return;

		checkOptionStatus();
	}

	const cityChanged = function () {
		const warehouseSelect = elm.querySelector('#warehouse');
		console.log(warehouseSelect);
		const warehouse = warehouseSelect.closest('select-choices');

		warehouse.choices.clearChoices(true, true);
		warehouse.autocomplete('');
	};
};

export const model = {
	active: false
};
